module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.examFormVisible,
      "close-on-click-modal": false,
      "width": "88%"
    },
    on: {
      "update:visible": function($event) {
        _vm.examFormVisible = $event
      }
    }
  }, [_vm._l((_vm.exams), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }, [_vm._v(">\n            \n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px 20px"
      }
    }, [(item.questionType === 1 || item.questionType === 2) ? _c('div', {}, [_c('el-radio-group', {
      model: {
        value: (item.yourAnswer),
        callback: function($$v) {
          _vm.$set(item, "yourAnswer", $$v)
        },
        expression: "item.yourAnswer"
      }
    }, _vm._l((item.answerList), function(answer, aindex) {
      return _c('div', {
        key: aindex,
        staticClass: "myradio"
      }, [_c('el-radio', {
        attrs: {
          "label": answer.optionsCode
        }
      }, [_vm._v(_vm._s(answer.optionsCode) + "、" + _vm._s(answer.optionsContent))])], 1)
    }), 0)], 1) : _c('div', [_c('el-checkbox-group', {
      on: {
        "change": function($event) {
          return _vm.handleCheckbox(index)
        }
      },
      model: {
        value: (_vm.checkList[index]),
        callback: function($$v) {
          _vm.$set(_vm.checkList, index, $$v)
        },
        expression: "checkList[index]"
      }
    }, _vm._l((item.answerList), function(answer, aindex) {
      return _c('div', {
        key: aindex
      }, [_c('el-checkbox', {
        attrs: {
          "label": answer.optionsCode
        }
      }, [_vm._v(_vm._s(answer.optionsCode) + "、" + _vm._s(answer.optionsContent))])], 1)
    }), 0)], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    style: (_vm.showButtonvisible),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.examFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7473835a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exam/exam.vue
// module id = 1182
// module chunks = 2